import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import { adapterAssetInfo, resetAdapterAssetDetails } from "../../redux/actions";
import Adapter from "../../components/adapter";

class AdapterPage extends Component {
  getBackLink = () => {
    const params = new URLSearchParams(this.props.location.search);
    return params.get("from") === "adapters" ? "/devices?view=adapters" : "/devices";
  };

  componentWillUnmount() {
    this.props.resetAdapterAssetDetails();
  }

  render() {
    const { translate, adapterAssetInfo, adapterAsset, activeFeatures, appSettingsLoaded } = this.props;
    const { params } = this.props.match;

    if (appSettingsLoaded && !activeFeatures?.some(feature => feature.featureName === 'lrp_free_features')) {
      return <Redirect to="/devices" />;
    }

    return (
      <Adapter
        translate={translate}
        adapterAssetInfo={adapterAssetInfo}
        adapterSerialNo={params.serialno}
        adapterAsset={adapterAsset}
        backLink={this.getBackLink()}
      />
    );
  }
}

const mapDispatchToProps = dispatch => ({
  adapterAssetInfo: serialNo => {
    dispatch(adapterAssetInfo(serialNo));
  },
  resetAdapterAssetDetails: () => {
    dispatch(resetAdapterAssetDetails());
  }
});

const mapStateToProps = state => ({
  adapterAsset: state.deviceReducer.adapterAsset,
  activeFeatures: state.appSettingReducer.activeFeatures,
  appSettingsLoaded: !!state.appSettingReducer.lastResponse
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdapterPage);
